module.exports = __webpack_public_path__ + "frontend/images/pattern/pricing/gold.jpg?02c74743240f7b94bf6d0613e0574626";